// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.

// TODO : Refactor the state to match the equipment group mapping in the backend to avoid this normaliation step and sorting group  to add equipment group mapping to equipment inside group and chidlren(parent ID that breaks the react flow UI if not in the right order)

export const normalizeGroupsWithHierarchy = (groups = [], companyEquipment = []) => {
  const facilityGroup = groups.find(g => g.name === g.studio_uuid);

  const facilityId = facilityGroup?.equip_group_uuid;

  const idSet = new Set(groups.map(g => g.equip_group_uuid));

  return sortGroupsByHierarchy(
    groups.map(g => {
      const base = normalizeGroup(g, companyEquipment);

      // Don t attach parent to the facility itself
      if (base.equip_group_uuid === facilityId) {
        return {
          ...base,
          parent_uuid: null,
        };
      }

      // assign parent if exists, otherwise fallback to facility
      let parent = base.parent_uuid;

      // if invalid parent → attach to facility
      if (!parent || !idSet.has(parent)) {
        parent = facilityId;
      }

      return {
        ...base,
        parent_uuid: parent,
      };
    })
  );
};

export const normalizeGroup = (group, companyEquipment = []) => {
  const companyMap = companyEquipment.length
    ? new Map(companyEquipment.map(e => [e.co_equip_uuid, e]))
    : null;

  const equipment = (group.equipment_group_mappings ?? []).map(
    ({ company_equipment: eq, direct_member: directMember }) => {
      const base = companyMap?.get(eq.co_equip_uuid);

      return base
        ? {
            ...base,
            ...eq,
            current_config: {
              ...base.current_config,
              ...eq.current_config,
            },
            direct_member: directMember,
          }
        : { ...eq, direct_member: directMember };
    }
  );

  return { ...group, equipment };
};

// helper function to avoid react flow issues with group being rendered before its children in the fetch equipment groups from backend
export const sortGroupsByHierarchy = (groups = []) => {
  const map = new Map(groups.map(g => [g?.equip_group_uuid, g]));
  const visited = new Set();
  const visiting = new Set();
  const result = [];

  const visit = group => {
    if (!group?.equip_group_uuid) {
      return;
    }

    const id = group.equip_group_uuid;

    if (visited.has(id) || visiting.has(id)) {
      return;
    }

    visiting.add(id);

    let updatedGroup = group;
    if (group?.parent_uuid) {
      const parent = map.get(group.parent_uuid);

      if (!parent) {
        updatedGroup = {
          ...group,
          parent_uuid: null,
        };
      } else if (parent?.equip_group_uuid !== id) {
        visit(parent);
      }
    }

    visiting.delete(id);
    visited.add(id);
    result.push(updatedGroup);
  };

  groups.forEach(visit);

  return result;
};
